export default [
  {
    path: '/admin_users',
    name: 'admin_users.index',
    component: require('./index').default,
    meta: {
      title: '管理员管理',
      navbar: 'el-icon-s-check',
      permission: 'admin_users.read'
    }
  },
  {
    path: '/admin_users/new',
    name: 'admin_users.new',
    component: require('./new').default,
    meta: {
      title: '新建管理员',
      permission: 'admin_users.create'
    }
  },
  {
    path: '/admin_users/:id',
    name: 'admin_users.show',
    component: require('./show').default,
    meta: {
      title: '管理员详情',
      permission: 'admin_users.read'
    }
  },
  {
    path: '/admin_users/:id/edit',
    name: 'admin_users.edit',
    component: require('./edit').default,
    meta: {
      title: '编辑管理员',
      permission: 'admin_users.update'
    }
  }
]
